import type { ClinicalQualityRecommendation } from '@cartwheel/components'
import { ClinicalQualityScoreChip, DataTable } from '@cartwheel/components'
import { useState } from 'react'
import { formatDate } from '../lib/date-utils'
import {
  ClinicalQualityScoreRowActions,
  type LatestScoreSummary,
} from './clinical-quality-score-row-actions'

export interface ClinicianChartNote {
  id: string
  created_at: string | null
  name: string | null
  note_type: string | null
  patient_name: string | null
  finished: boolean | null
  healthie_url: string | null
  client_id: string | null
  latest_clinical_quality_score: LatestScoreSummary | null
  scoring_in_progress?: boolean
}

interface ClinicianChartNoteRowProps {
  chartNote: ClinicianChartNote
}

export function ClinicianChartNoteRow({ chartNote }: ClinicianChartNoteRowProps) {
  const [localLatestScore, setLocalLatestScore] = useState(chartNote.latest_clinical_quality_score)
  const latestScore = localLatestScore

  return (
    <DataTable.Row>
      <DataTable.Cell className="text-sm text-charcoal whitespace-nowrap">
        {chartNote.created_at ? formatDate(chartNote.created_at) : '—'}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm text-charcoal">
        {chartNote.note_type ?? chartNote.name ?? '—'}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm text-charcoal whitespace-nowrap">
        {chartNote.client_id && chartNote.patient_name ? (
          <a href={`/students/${chartNote.client_id}`} className="text-indigo hover:underline">
            {chartNote.patient_name}
          </a>
        ) : (
          chartNote.patient_name || '—'
        )}
      </DataTable.Cell>
      <DataTable.Cell className="text-sm whitespace-nowrap">
        <ClinicalQualityScoreChip
          percentage={latestScore?.percentage ?? null}
          recommendation={latestScore?.recommendation as ClinicalQualityRecommendation | null}
        />
      </DataTable.Cell>
      <DataTable.Cell className="whitespace-nowrap">
        {chartNote.healthie_url ? (
          <a
            href={chartNote.healthie_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo hover:underline text-sm whitespace-nowrap"
          >
            View in Healthie
          </a>
        ) : null}
      </DataTable.Cell>
      <DataTable.Cell className="text-right whitespace-nowrap">
        {chartNote.client_id ? (
          <ClinicalQualityScoreRowActions
            chartNoteId={chartNote.id}
            clientId={chartNote.client_id}
            latestScore={latestScore}
            scoringInProgress={chartNote.scoring_in_progress}
            onScoreComplete={setLocalLatestScore}
          />
        ) : (
          <span className="text-xs text-charcoal-50 italic">
            {chartNote.patient_name ? 'Patient not found in Cartwheel' : 'No patient attached'}
          </span>
        )}
      </DataTable.Cell>
    </DataTable.Row>
  )
}
